module.exports = "/images/Spain.png?ec65e91aaf1e532b3fbc2440eae64012";